import React, { createContext, useContext, useState, useCallback } from 'react';

const PriceContext = createContext();

export const usePrice = () => {
  const context = useContext(PriceContext);
  if (!context) {
    throw new Error('usePrice must be used within PriceProvider');
  }
  return context;
};

export const PriceProvider = ({ children }) => {
  const [ethPrice, setEthPrice] = useState(0);

  const updateEthPrice = useCallback((price) => {
    setEthPrice(price);
  }, []);

  const formatUSD = useCallback((value) => {
    return `$${parseFloat(value).toFixed(2)}`;
  }, []);

  return (
    <PriceContext.Provider value={{ ethPrice, updateEthPrice, formatUSD }}>
      {children}
    </PriceContext.Provider>
  );
};
